import moment from 'moment';

export const toEndOfDayUTC = (date: moment.Moment): string => {
  return date.clone().endOf('day').utc().toISOString();
};
